import React from 'react';
import { Campaign, CampaignBanner, Product } from '../../../../types';
import PromoBanner from '../../../../components/campaign-banners/promo-banner';
import { getCampaignPromoBanners } from '../../utils';

const ProductDuringPromoBanner: React.FC<IProductPromoBannerProps> = props => {
  const { product, campaignBanners } = props;
  const campaignPromoBanners = getCampaignPromoBanners(campaignBanners);
  const campaignBannerLinkParams = product.category
    ? { category: product.category.id }
    : undefined;
  return campaignPromoBanners.during &&
    campaignPromoBanners.during.length > 0 ? (
    <div className="column small-12">
      <PromoBanner
        banners={campaignPromoBanners.during}
        linkParams={campaignBannerLinkParams}
      />
    </div>
  ) : null;
};

interface IProductPromoBannerProps {
  product: Product;
  campaignBanners: {
    active: (CampaignBanner & {
      campaign: Pick<Campaign, 'media'>;
    })[];
  };
}

export default ProductDuringPromoBanner;
